



<section class="our-portfolio">
    <div class="container-fluid">

        <div class="row">
          
            <div class="col-md-12">

                <div class="service">
            
                    <h1 class="fs-1 my-lg-5 pb-lg-5 text-center text-decoration-underline text-right">
                        {{"compony portfolio" | translate}}
                    </h1>
                    
                </div>
            
            </div>
                        
            <div 
            class="col-md-6 p-4 p-lg-5" 
            *ngFor="let work of works; let i = index" 
            >

                <div class="border border-warning p-4 rounded-3 shadow wrapper app-box" routerLink="/تفاصيل" (click)="setIndex(i)">
                    <div>
                        <img src="https://www.admin.codesroots.com/library/homepage/photo/umphotos/{{work.inside_photo}}" alt="{{work.name}}" class="w-100" />
                    </div> 
                    <h2 class="fs-4 fw-bold mt-4 py-2 rounded-3 text-center text-black app-title">{{work.name}}</h2>                   
                </div>    

            </div>

        </div>

    </div>
</section>